<template>
  <v-row>
    <!-- This is the We are sorry shown to user if access is NONE -->
    <v-col cols="12" class="my-12 py-5 px-4">
      <h3 class="heading_three text-center mb-3">
        {{ $t('L_restricted_policy_code_message_we_are_sorry') }}
      </h3>
      <h3 v-html="custServNum" class="text-h3 text-center mb-3" />
    </v-col>
  </v-row>
</template>

<script lang="ts">
import { useCustomerStore } from '@/stores/customer/customer.store';
import { useGlobalStore } from '@/stores/global/global.store';
import { mapStores } from 'pinia';
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'TermLifeCardPolicyAccessNone',
  computed: {
    ...mapStores(useGlobalStore, useCustomerStore),
    custServNum() {
      if (this.globalStore.getLocale.length > 0) {
        const withDash = this.customerStore.getCustServNumWDash(this.globalStore.getLocale);
        const withoutDash = this.customerStore.getCustServNumWODash(this.globalStore.getLocale);
        const num = this.$t('L_restricted_policy_code_number_call_num_for_help', {
          phoneWODash: withoutDash,
          phoneWDash: withDash,
        });
        return num;
      }
      return '';
    },
  },
});
</script>
